module.exports = __webpack_public_path__ + "static/media/cq_simulatore_blu_scuro.c0638133.svg";